import {
  Container,
  Column,
  Text,
  Row,
  Spacer
} from '@smuchile/pkg-unimarc-components'
import { isValidArrayWithData } from '@smuchile/pkg-unimarc-hooks'
import { SquareButton } from './SquareButton'
import { v4 as uuid } from 'uuid'
import { getBemId } from '@smuchile/pkg-unimarc-components/helpers'
import { IAvailableWindowWithExpress } from '../types'

export interface TimeOptionsProps {
  availableTimes: IAvailableWindowWithExpress[]
  cartSubtotal?: string | number
  isMobile?: boolean | string
  scheduleSelected: IAvailableWindowWithExpress
  handleSchedule: (date: IAvailableWindowWithExpress) => void
  onBlockedExpressClick?: (date: IAvailableWindowWithExpress) => void
}

export const TimeOptions = ({
  availableTimes,
  cartSubtotal,
  isMobile = false,
  scheduleSelected,
  handleSchedule,
  onBlockedExpressClick
}: TimeOptionsProps): React.ReactElement => {
  return (
    <Container>
      <Column id={getBemId('shipmentHour', 'container')}>
        <Text
          fontSize={isMobile ? 'md' : 'lg'}
          fontWeight='medium'
          id={getBemId('shipmentHour', 'title')}
        >
          Hora
        </Text>
        <Spacer.Horizontal size={20} />
        <Row
          gap={23}
          id={getBemId('shipment', 'hoursContainer')}
          isWrap
        >
          {isValidArrayWithData(availableTimes) &&
            availableTimes.map((window, index) => {
              return (
                <SquareButton
                  cartSubtotal={cartSubtotal}
                  date={window}
                  endDate={window?.endDateUtc}
                  handleSchedule={handleSchedule}
                  index={index}
                  isMobile={isMobile}
                  key={uuid()}
                  onBlockedExpressClick={onBlockedExpressClick}
                  price={window?.price}
                  scheduleSelected={scheduleSelected}
                  startDate={window?.startDateUtc}
                />
              )
            })}
        </Row>
      </Column>
    </Container>
  )
}
